import {Controller, useFormContext} from 'react-hook-form';
import {Dialog} from '@reach/dialog';
import {DialogFooter, DialogTitle} from '../../../../../../components/Dialog';
import React, { useEffect } from 'react';
import Button, {ButtonGroup} from '../../../../../../components/Button';
import {LocationFormField} from '../../types';
import {
  ErrorMessage,
  FormGroup,
  FormItemGroup,
  Input,
  RequireMarker,
  Radio,
} from '../../../../../../components/form-items';
import LocationAddress from './location-address';
import IPAddress from './ip-address';
import WebIPLimitInfo from '@gakki/components/info-tip/web-ip-limit-info';

type LocationFormProps = {
  isOpen?: boolean;
  onClose: () => void;
  onConfirm: (data: LocationFormField) => void;
  defaultValue?: LocationFormField;
};
const LocationForm = function (props: LocationFormProps) {
  const {isOpen, onClose, onConfirm, defaultValue} = props;
  const {control, register, errors, handleSubmit, watch} =
    useFormContext<LocationFormField>();
  const enableWebIPCheckInValue = watch('enableWebIPCheckIn')

  return (
    <Dialog isOpen={isOpen} className={'!w-[500px] text-xs'} aria-label="location-dialog">
      <DialogTitle title={'打卡地點設定'} onClose={onClose} />
      <form className={'mt-2 location-form'} onSubmit={handleSubmit(onConfirm)}>
        <input type={'hidden'} ref={register} name={'idx'} />
        <div
          className={
            'flex flex-col py-3 pb-0 pt-[18px] border-b border-[#e9eced] mb-5'
          }
        >
          <FormGroup columnTemplates={1}>
            <FormItemGroup>
              <label>
                地點名稱
                <RequireMarker />
              </label>
              <Input
                className={'!h-[26px]'}
                ref={register({required: '地點名稱為必填'})}
                name={'locationName'}
                defaultValue={''}
                placeholder={'請輸入地點名稱'}
                error={errors?.locationName?.message}
              />
              <ErrorMessage>{errors?.locationName?.message}</ErrorMessage>
            </FormItemGroup>
          </FormGroup>
          <LocationAddress />
          <FormItemGroup data-tset-id={'enable-web-ip-checkin'}>
            <label htmlFor={'enableWebIPCheckIn'}>
              限制網頁打卡IP位置
              <WebIPLimitInfo/>
            </label>
            <Controller
              control={control}
              name={'enableWebIPCheckIn'}
              defaultValue={false}
              render={({onChange, value}) => (
                <div className="flex items-center gap-[50px] text-[15px] h-[38px]">
                  <Radio
                    onChange={e => {
                      onChange(true);
                    }}
                    value={'true'}
                    checked={String(value) === 'true'}
                  >
                    是
                  </Radio>
                  <Radio
                    value={'false'}
                    checked={String(value) === 'false'}
                    onChange={e => {
                      onChange(false);
                    }}
                  >
                    否
                  </Radio>
                </div>
              )}
            />
          </FormItemGroup>
          { enableWebIPCheckInValue && <IPAddress /> }
        </div>
        <DialogFooter>
          <ButtonGroup direction={'rtl'}>
            <Button type={'submit'} variant={'cta'} className={'confirm'}>
              確定
            </Button>
            <Button variant={'primary'} className={'close'} onClick={onClose}>
              取消
            </Button>
          </ButtonGroup>
        </DialogFooter>
      </form>
    </Dialog>
  );
};

export default LocationForm;
